import { Outlet } from "react-router-dom";
import Navbar from "../components/UI/Navbar/Navbar";

const ProjectsLayout = () => {
  return (
    <div>
      <Navbar />
      <Outlet />
    </div>
  );
};

export default ProjectsLayout;
